/* eslint-disable max-len */
import React from 'react';
function MyLearning() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9 3.99999H11V8.99999L10 8.24999L9 8.99999V3.99999ZM6 20H18V3.99999H13V13L10 10.75L7 13V3.99999H6V20Z" })));
}
export default MyLearning;
